import styled from "styled-components";
import { ONBOARDING_PHONE_GUTTER } from "features/onboarding/common/onboardingUi";
import {
  cardSurface,
  eyebrowText,
  revealChildren,
  stepDescription,
  stepTitle,
} from "features/onboarding/common/onboardingUi";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens";

const WelcomeLayout = styled.div`
  width: 100%;
  max-width: 1040px;
  margin: 0 auto 16px;
  /* The step container already keeps a 16px phone gutter. */
  @media (max-width: 560px) {
    padding: 0;
    box-sizing: border-box;
  }
`;
// Steps on the list and exchange routes (channels, DCA presets, demo account)
// sit in an edge-to-edge container on phones, so this layout brings its own
// gutter there (the onboarding's phone gutter).
export const ListStepLayout = styled(WelcomeLayout)`
  @media (max-width: 560px) {
    padding: 0 ${ONBOARDING_PHONE_GUTTER}px;
  }
`;
export const HeadingBlock = styled.div`
  ${revealChildren(0, 4)};
  text-align: center;
  max-width: 720px;
  margin: 0 auto 24px;
  > div {
    justify-content: center;
  }
  /* Phones: a left-aligned heading under the journey line, which already
     names the step, so the step's own eyebrow (its first child) goes. */
  @media (max-width: 560px) {
    padding-top: 0;
    margin: 0 0 16px;
    max-width: none;
    text-align: left;
    > div {
      justify-content: flex-start;
    }
    > div:first-child {
      display: none;
    }
    h1 {
      margin: 8px 0 4px;
      font-size: 21px;
      line-height: 28px;
    }
    > p {
      margin: 0;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;
export const Eyebrow = styled.div`
  ${eyebrowText};
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: inherit;
  svg {
    flex-shrink: 0;
  }
`;
export const HeroTitle = styled.h1`
  ${stepTitle};
  margin: 8px 0 4px;
`;
export const Lead = styled.p`
  ${stepDescription};
  max-width: 560px;
  margin: 0 auto;
`;
export const WelcomeGrid = styled.div`
  ${revealChildren(3, 3)};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;
export const Choice = styled.section`
  ${cardSurface};
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  @media (max-width: 480px) {
    padding: 16px;
  }
`;
export const SectionTitle = styled.h2`
  ${newLookType.panelTitle};
  color: ${(p) => p.theme.colors.titleColor};
  margin: 12px 0 4px;
`;
export const SmallNote = styled.p`
  ${newLookType.meta};
  color: ${(p) => getNewLookTokens(p.theme).muted};
  text-align: center;
  margin: 12px 0 0;
`;
